<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Visi</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button :disabled="cek_visi" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f text-center">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 15%">Periode RPJMD</th>
                            <th class="text-center" style="width: 40%">Uraian Visi</th>
                            <th class="text-center" style="width: ">Keterangan</th>
                            <th class="text-center" style="width: 15%">Edit</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="9" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="(data, index) in list_visi" :key="data.visi_id">
                                    <td class="text-center tabel_center">{{index+1}}</td>
                                    <td class="text-center tabel_center">{{data.periode}}</td>
                                    <td class="tabel_center">{{data.uraian}}</td>
                                    <td class="text-justify tabel_center">{{data.keterangan}}</td>

                                    <td class="text-center tabel_center" >
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                        &nbsp;
                                        <button @click="removeData(data.visi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>


                        </tbody>
                    </table>
                </div>

                <!-- <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr> -->

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                            <form @submit.prevent="addData()">
                                <div class="modal-body">
                                    <div class="padding_form_input">
                                        <div class="row clearfix padding_bawah">
                                            <span class="huruf_input">Periode RPJMD</span>
                                            <!-- <input type="text" class="form-control"> -->
                                            <select name="" id="" class="form-control" v-model="rpjmd_id">
                                                <option v-for="data in list_rpjmd" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                            </select>
                                        </div>  
                                      
                                        <div class="row clearfix padding_bawah">
                                            <span class="huruf_input">Uraian Visi</span>
                                            <textarea rows="4" v-model="uraian" class="form-control no-resize" placeholder="Masukan Uraian Visi..."></textarea>
                                        </div>
                                        
                                        <div class="row clearfix padding_bawah">
                                            <span class="huruf_input">Keterangan</span>
                                            <textarea rows="4" v-model="keterangan" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">
                                    <div class="padding_form_input">
                                        <div class="row clearfix padding_bawah">
                                            <span class="huruf_input">Periode RPJMD</span>
                                            <!-- <input type="text" class="form-control"> -->
                                            <select name="" id="" class="form-control" v-model="rpjmd_id">
                                                <option v-for="data in list_rpjmd" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                            </select>
                                        </div>  
                                      
                                        <div class="row clearfix padding_bawah">
                                            <span class="huruf_input">Uraian Visi</span>
                                            <textarea rows="4" v-model="uraian" class="form-control no-resize" placeholder="Masukan Uraian Visi..."></textarea>
                                        </div>
                                        
                                        <div class="row clearfix padding_bawah">
                                            <span class="huruf_input">Keterangan</span>
                                            <textarea rows="4" v-model="keterangan" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                        </div>
                                    </div>


                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL = URL_APP+'api/v1/planning_visi/';


    export default {
        name: "planning_urusan",
        data() {
            return {
                // data:{
                //     id: '',
                //     kode_urusan: '',
                //     nama_urusan: '',
                //     user: '',
                //     createdtime: ''
                // },
                uraian: '',
                keterangan: '',
                visi_id: '',
                rpjmd_id: '',
                list_visi: [],
                list_rpjmd: [],
                
                cek_visi : false,

                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'create', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        rpjmd_id : this.rpjmd_id,
                        uraian : this.uraian,
                        keterangan : this.keterangan
                    })
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_visi) => {
                  this.list_visi = data_visi.data;
                  var jml_data = this.list_visi
                  // this.page_last = data_visi.jml_data;
                    this.cek_load_data = false;
                  if (jml_data.length <= 0) {
                      this.cek_visi = false;
                  } else {
                      this.cek_visi = true;
                  }
                })
            },
            getDataRPJMD: function(){
                fetch(ADD_URL_RPJMD+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                  this.list_rpjmd = data_rpjmd.data;
                  // this.page_last = data_visi.jml_data;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                      visi_id: this.visi_id,
                      uraian: this.uraian,
                      keterangan: this.keterangan,
                      rpjmd_id: this.rpjmd_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
              this.getDataRPJMD();
                this.visi_id = data.visi_id;
                this.uraian = data.uraian;
                this.rpjmd_id = data.rpjmd_id;
                this.keterangan = data.keterangan;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"delete", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          visi_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            // emptyData : function(){
            //     this.data = {
            //         id: '',
            //         kode_urusan: '',
            //         nama_urusan: '',
            //         user: '',
            //         createdtime: ''
            //     };
            //     this.kode_urusan= '';
            //     this.nama_urusan= '';
            //     this.id_urusan= '';
            // },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================
        mounted : function(){
            this.getDataRPJMD();
            this.getData();
        }

    };
</script>
